import {format} from "date-fns";
import {MOSTRADOR} from "../config/constants";


class Utils {
    /**
     * Formatear date
     * @param date
     * @returns {string}
     */
    static formatDate(date) {
        return format(date, 'dd/MM/yyyy HH:mm:ss');
    }

    /**
     * Formatear date
     * @param date
     * @returns {string}
     */
    static formatDateWithoutHour(date) {
        if (date) {
            return format(date, 'dd/MM/yyyy');
        }

        return '';
    }

    /**
     * Primera letra en mayuscula
     * @param string
     * @returns {string}
     */
    static toCapitalize(string) {
        if (string && string.length > 0)
            return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()

        return string;
    }

    /**
     * Comprobar si es un producto especial
     * @param refProduct
     * @returns {*}
     */
    static checkRefProduct(refProduct) {
        return window.env.REACT_APP_VENTAS_PRODUCTOS_EXCLUIR.split(',').includes(refProduct.replace(/\d+/g, ''));
    }

    /**
     * Comprobar si estamos en un movil o ordenador
     * @returns {boolean}
     */
    static isMobile() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    }

    /**
     * Ejecutar sonido
     * @param sound
     */
    static playAudio(sound) {
        const audio = new Audio(sound);
        audio.play();
    }

    /**
     * Comprobar que valor no es nulo ni esta undefinied
     * @param value
     * @returns {boolean}
     */
    static isEmpty(value) {
        return value === null || value === undefined;
    }

    static isFullEmpty(value) {
        return value === null || value === undefined || value === '';
    }

    /**
     * Obtener año actual
     * @returns {number}
     */
    static getCurrentYear() {
        return (new Date()).getFullYear();
    }

    /**
     * Generar array de años
     * @returns {[]}
     */
    static getArrayYears() {
        const years = [];
        for (let year = Utils.getCurrentYear(); year >= 2023; year--) {
            years.push({label: year, value: (year === Utils.getCurrentYear() ? '' : year)});
        }
        return years;
    }

    /**
     * Comprobar si tiene serie y albaran
     * @param {string|number} order - Número a validar (formato esperado SERIE-ALBARAN)
     * @returns {boolean} false si es null/undefined o no tiene formato SERIE-ALBARAN
     */
    static checkOrder(order) {
        if (order === null || order === undefined) {
            return false;
        }
        // DECISION: coercionar a string. order.num puede ser numérico (id de grupo en
        // OrderN2Grupo), y un .split() directo lanzaba TypeError
        return String(order).split('-').length === 2;
    }

    /**
     * Obtener orden en serie y numero
     * @param {string|number} order - Número en formato SERIE-ALBARAN
     * @returns {{serie: (string|undefined), order: (string|undefined)}} Sin serie cuando
     *   el valor no tiene guion (p. ej. un id de grupo), y ambos undefined si no hay valor.
     *   Comprobar `serie` antes de usarlo: los endpoints que la exigen fallarán sin ella
     */
    static getOrder(order){
        if (order === null || order === undefined) {
            return {};
        }

        // DECISION: coercionar a string igual que checkOrder. order.num puede ser numérico
        // (id de grupo en OrderN2Grupo) y un .split() directo lanzaba TypeError
        const orderSplit = String(order).split('-');

        if (orderSplit.length === 1) {
            return {order: orderSplit[0]}
        }
        return {serie: orderSplit[0], order: orderSplit[1]}
    }

    /**
     * Ver si transporte esta en los que son mostrador
     * @param transport
     * @returns {string}
     */
    static getTransport(transport) {
        const transportNormalize = transport?.trim()?.toLowerCase();
        const transports = MOSTRADOR.map(ruta => ruta.trim().toLowerCase());
        return transports.includes(transportNormalize);
    }

    static slugify(text) {
        return text
            .toLowerCase()
            .normalize('NFD')                      // separa caracteres acentuados
            .replace(/[\u0300-\u036f]/g, '')       // elimina los acentos
            .replace(/[^a-z0-9]+/g, '-')           // reemplaza no alfanuméricos por guión
            .replace(/^-+|-+$/g, '')               // quita guiones al inicio y fin
            .trim();
    }

    /**
     * Obtener nombre del mes
     * @param mes - Número del mes (1-12)
     * @returns {string} - Nombre del mes en español
     */
    static getNombreMes(mes) {
        const meses = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        return meses[mes - 1] || mes;
    }
}

export default Utils;